import { render, staticRenderFns } from "./UsersComponent.vue?vue&type=template&id=2782e74c"
import script from "./UsersComponent.vue?vue&type=script&lang=js"
export * from "./UsersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports